export function StatusBadge({ status }) {
  const map = {
    pending: { label: "Pending Print", cls: "bg-amber-50 text-amber-700 border-amber-200" },
    completed: { label: "Completed", cls: "bg-green-50 text-green-700 border-green-200" },
    awaiting_details: { label: "Awaiting Details", cls: "bg-slate-100 text-slate-600 border-slate-200" },
    cancelled_by_customer: { label: "Cancelled by customer", cls: "bg-red-50 text-red-600 border-red-200" },
  };
  const s = map[status] || map.pending;
  return (
    <span className={`inline-flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1 rounded-full border ${s.cls}`} data-testid={`status-${status}`}>
      <span className="w-1.5 h-1.5 rounded-full bg-current" />
      {s.label}
    </span>
  );
}
